(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bellzi-quiz"] && !Shopify.designMode) return;
  try {
    
(() => {
const init = (scope) => {
scope.querySelectorAll('[data-bellzi-quiz]').forEach(root => {
if(root.dataset.ready) return;
root.dataset.ready='true';
const questions=Array.from(root.querySelectorAll('[data-quiz-data]'),el=>JSON.parse(el.getAttribute('data-quiz-data')));
const intro=root.querySelector('.quiz-intro'), stage=root.querySelector('.quiz-stage'), result=root.querySelector('.quiz-result'), title=root.querySelector('[data-quiz-question]'), options=root.querySelector('.quiz-answers');
let answers=[], step=0;
root.querySelector('[data-quiz-total]').textContent=questions.length;root.querySelector('progress').max=questions.length;
function render(){intro.hidden=true;result.hidden=true;stage.hidden=false;root.querySelector('[data-quiz-step]').textContent=step+1;root.querySelector('progress').value=step+1;title.textContent=questions[step].title;options.replaceChildren();questions[step].answers.forEach((answer,index)=>{const b=document.createElement('button');b.type='button';b.className='quiz-answer';b.textContent=answer.label;b.setAttribute('aria-pressed',String(answers[step]===index));b.addEventListener('click',()=>choose(index));options.append(b)});title.focus({preventScroll:true});}
function choose(index){answers[step]=index;if(step<questions.length-1){step++;render();return;}const scores=Array(12).fill(0);answers.forEach((a,i)=>Object.entries(questions[i].answers[a].scores).forEach(([id,value])=>scores[Number(id)]+=value));const top=Math.max(...scores);const tied=scores.map((v,i)=>v===top?i:-1).filter(i=>i>=0);const match=tied.sort((a,b)=>{for(let i=answers.length-1;i>=0;i--){const weights=questions[i].answers[answers[i]].scores;const diff=(weights[b]||0)-(weights[a]||0);if(diff)return diff;}return a-b})[0];stage.hidden=true;result.hidden=false;root.querySelectorAll('[data-match]').forEach(el=>el.hidden=Number(el.dataset.match)!==match);const reasons=root.querySelector('[data-quiz-reasons]');reasons.replaceChildren();answers.map((a,i)=>questions[i].answers[a]).filter(a=>a.scores[match]).sort((a,b)=>b.scores[match]-a.scores[match]).slice(0,2).forEach(a=>{const li=document.createElement('li');li.textContent=a.label;reasons.append(li)});result.querySelector('[data-match="'+match+'"] h3').focus({preventScroll:true});}
root.querySelector('[data-quiz-start]').addEventListener('click',()=>{answers=[];step=0;render()});root.querySelector('.quiz-back').addEventListener('click',()=>{if(step>0){step--;render()}else{stage.hidden=true;intro.hidden=false;root.querySelector('[data-quiz-start]').focus()}});root.querySelector('.quiz-restart').addEventListener('click',()=>{answers=[];step=0;render()});
});};init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(function(){
  const mobile = window.matchMedia('(max-width: 749px)');
  function initializeFooter(){
    document.querySelectorAll('.footer-disclosure').forEach(function(details){
      const summary = details.querySelector('summary');
      details.open = !mobile.matches;
      summary.tabIndex = mobile.matches ? 0 : -1;
      if (!details.dataset.footerReady) {
        summary.addEventListener('click', function(event){if(!mobile.matches) event.preventDefault();});
        details.dataset.footerReady = 'true';
      }
    });
  }
  initializeFooter();
  mobile.addEventListener('change', initializeFooter);
  document.addEventListener('shopify:section:load', initializeFooter);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
(function(){function setup(){if(!('IntersectionObserver' in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;document.querySelectorAll('.collection-directory:not([data-motion-ready])').forEach(function(root){root.dataset.motionReady='true';var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-arriving');observer.unobserve(entry.target);}});},{threshold:.12});root.querySelectorAll('.directory-card').forEach(function(card){observer.observe(card);});});}setup();document.addEventListener('shopify:section:load',setup);})();

  } catch(e) { console.error(e); }
})();
})();
